module.exports = __webpack_public_path__ + "static/media/fennel.cef65bf6.jpg";